<div class="okta-container">
  <div class="row okta-wrapper">
    <div class="okta-form-row"  *ngIf="websiteName =='Parmed'|| (websiteName== 'Major'&& !isDesktopDevice())">
      <div class="row logo-holder">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
          <img class="app-logo" src="/assets/images/{{websiteName}}/LogoNew.png" alt="" />
        </div>
      </div>
      <div class="row box-container">
        <form name="changeQuestionForm" #changeQuestionForm="ngForm" novalidate class="form-info" (ngSubmit)="onSecurityQuestionSubmit(changeQuestionForm)">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p class="exp-message">Change Security Question</p>
            <div class="has-error okta-error" *ngIf="update.errorMessage">
              <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
              <p class="show-message">
                <span title="{{update.errorMessage}}">{{update.errorMessage}}</span>
              </p>
            </div>
            <ul class="form-grid">
              <li class="question-control">
                <mat-select id="question" name="question" [(ngModel)]="update.question" #question="ngModel" required placeholder="Choose Security Question"
                  parAutoFocus>
                  <mat-option *ngFor="let question of securityQuestions; let i = index" value="{{question.questionText}}">
                    <span id="question-{{i}}"> {{question.questionText}} </span>
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="question.errors?.required">Please select a security question.</mat-error>
              </li>
              <li class="question-control">
                <mat-form-field>
                  <input id="answer" matInput name="answer" type="password" required #answer="ngModel" placeholder="Answer" [(ngModel)]="update.answer"
                    [pattern]="validation.regex" parValidateEqual="confirmAnswer" reverse="true">
                  <mat-error *ngIf="answer.errors?.required">Answer is a required field.</mat-error>
                  <mat-error *ngIf="answer.errors?.pattern">Your answer must have at least {{validation.minLength}} characters.</mat-error>
                </mat-form-field>
              </li>
              <li class="question-control">
                <mat-form-field>
                  <input id="confirm-answer" matInput name="confirmAnswer" type="password" required #confirmAnswer="ngModel" placeholder="Confirm Answer" [(ngModel)]="update.confirmAnswer"
                    [pattern]="validation.regex" parValidateEqual="answer">
                  <mat-error *ngIf="confirmAnswer.errors?.required">Confirm answer is a required field.</mat-error>                 
                </mat-form-field>
              </li>
              <li class="password-hint">
                  <mat-error *ngIf="confirmAnswer.errors?.pattern">Confirm answer must have at least {{validation.minLength}} characters.</mat-error>
                  <mat-error *ngIf="!answer.errors?.pattern && !confirmAnswer.errors?.pattern && confirmAnswer.errors?.validateEqual">Answer and confirm answer do not match.</mat-error>
                <p>{{validation.infoMessage}}</p>
              </li>
              <li class="okta-action-buttons">
                <button id="btn-cancel" type="button" mat-raised-button color="accent" (click)="onCancelClick()">Cancel</button>
                <button id="btn-submit" type="submit" mat-raised-button color="accent" [disabled]="changeQuestionForm.invalid">Save</button>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="form-container-update major-change-form" *ngIf="websiteName =='Major'&& isDesktopDevice()">
    <form name="changeQuestionForm" #changeQuestionForm="ngForm" novalidate class="form-info" (ngSubmit)="onSecurityQuestionSubmit(changeQuestionForm)">
      <div class="has-error okta-error" *ngIf="update.errorMessage">
        <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
          <p class="show-message">
             <span title="{{update.errorMessage}}">{{update.errorMessage}}</span>
          </p>
      </div>
      <div class="form-group">
        <label for="answer">Select Security Question <span>*</span></label>
        <select type="text" id="question" name="question" [(ngModel)]="update.question" #question="ngModel" required placeholder="Choose Security Question"
            parAutoFocus>
        <option *ngFor="let question of securityQuestions; let i = index" value="{{question.questionText}}">
          <span id="question-{{i}}"> {{question.questionText}} </span>
        </option>
        </select>
        <mat-error *ngIf="question.errors?.required">Please select a security question.</mat-error>
      </div>
      <div class="form-group">
        <label for="answer">Answer <span>*</span></label>
        <input id="answer" matInput name="answer" type="password" required #answer="ngModel" placeholder="Answer" [(ngModel)]="update.answer"
          [pattern]="validation.regex" parValidateEqual="confirmAnswer" reverse="true">
            <mat-error *ngIf="answer.invalid && answer.touched">Answer is a required field.</mat-error>
            <mat-error *ngIf="answer.errors?.pattern">Your answer must have at least {{validation.minLength}} characters.</mat-error>
      </div>
 
      <div class="form-group">
        <label for="confirmAnswer">Confirm Answer <span>*</span></label>
        <input id="confirm-answer" matInput name="confirmAnswer" type="password" required #confirmAnswer="ngModel" placeholder="Confirm Answer" [(ngModel)]="update.confirmAnswer"
            [pattern]="validation.regex" parValidateEqual="answer">
          <mat-error *ngIf="confirmAnswer.invalid && confirmAnswer.touched">Confirm answer is a required field.</mat-error>  
      </div>
 
      <div class="note">
        <mat-error *ngIf="confirmAnswer.errors?.pattern">Confirm answer must have at least {{validation.minLength}} characters.</mat-error>
        <mat-error *ngIf="!answer.errors?.pattern && !confirmAnswer.errors?.pattern && confirmAnswer.errors?.validateEqual">Answer and confirm answer do not match.</mat-error>
        <p>{{validation.infoMessage}}</p>
      </div>
 
      <div class="btn-group">
        <button id="btn-cancel" type="button" mat-raised-button color="accent" (click)="onCancelClick()">Cancel</button>
        <button id="btn-submit" type="submit" mat-raised-button color="accent" [disabled]="changeQuestionForm.invalid">Save</button>
      </div>
    </form>
  </div>
</div>